import React, { useState } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import "./App.css";

function App() {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Hi 👋 I'm your AI Travel Planner! Where would you like to go?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // 👉 Replace this with your deployed API Gateway endpoint
  const API_URL = "https://whvqwbv9u9.execute-api.ap-south-1.amazonaws.com/prod/travel";

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", text: input }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
      const response = await axios.post(API_URL, { message: input });
      const reply = response.data.reply || "Sorry, I couldn't generate an itinerary.";

      setMessages([
        ...newMessages,
        { role: "assistant", text: reply }
      ]);
    } catch (error) {
      console.error(error);
      setMessages([
        ...newMessages,
        { role: "assistant", text: "⚠️ There was an error contacting the travel planner." }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`message ${msg.role === "user" ? "user" : "assistant"}`}
          >
            <ReactMarkdown>{msg.text}</ReactMarkdown>
          </div>
        ))}

        {loading && (
          <div className="message assistant typing">Travel planner is typing...</div>
        )}
      </div>

      <div className="input-box">
        <input
          type="text"
          placeholder="Ask about your travel plan..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
}

export default App;
